module.exports = __webpack_public_path__ + "static/media/moatti.3de71bfb.jpg";